module.exports = __webpack_public_path__ + "img/requirementEngineering_sign.5df8f738.png";